module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "uploader"
  }, [_c('form', {
    style: (_vm.formStyle),
    attrs: {
      "method": "post",
      "action": "upload-page.php",
      "enctype": "multipart/form-data"
    }
  }, [_c('input', {
    ref: "filesInput",
    attrs: {
      "id": "filesToUpload",
      "name": "filesToUpload[]",
      "type": "file",
      "multiple": ""
    }
  })]), _vm._t("header", null, {
    "files": _vm.files
  }), _vm._l((_vm.files), function(file) {
    return _vm._t("file", [_c('div', [_vm._v(_vm._s(file.name))])], {
      "fileInfo": file
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7b6641ee","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/tools/Uploader.vue
// module id = 999
// module chunks = 2 6